import { Component, Input} from '@angular/core';
import { EveReportingWidget, EveReportingWidgetType } from './widget.component';




@Component({
  selector: 'widget-menu-settings',
  templateUrl: 'widget-menu-settings.component.html',
  styleUrls: ['./widget-menu-settings.component.css']
})
export class WidgetMenuSettingsComponent {

  @Input()
  widget?: EveReportingWidget = null;




  widgetTypes = EveReportingWidgetType;


  constructor(
    
  )
  {

  }
}


